(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
    document.addEventListener('filters:updated', function () {
      var grid = document.querySelector('#product-grid');
      if (!grid) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      grid.scrollIntoView({
        behavior: prefersReduced ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  
  } catch(e) { console.error(e); }
})();
})();
